import { gql } from '@/features/graphql/generated'

export const CartItemsFragment = gql(/* GraphQL */ `
    fragment CartItems on Cart {
        __typename
        key
        items {
            ...CartItem
        }
    }
`)

export const CartContainerItemsFragment = gql(/* GraphQL */ `
    fragment CartContainerItems on Cart {
        __typename
        key
        containerItems {
            ...CartContainerItem
        }
    }
`)

export const CartFragment = gql(/* GraphQL */ `
    fragment Cart on Cart {
        __typename
        ...CartItems
        ...CartContainerItems
    }
`)
